module.exports = __webpack_public_path__ + "img/优惠券.3613d6ea.png";